import styled, { css } from 'styled-components';

interface ItemPropsInterface {
  border: boolean;
}

export const Item = styled.li<ItemPropsInterface>`
  ${({ theme, border }) => css`
    position: relative;
    list-style-type: none;

    :not(:first-child) {
      margin-top: ${theme.spacing.km4};
    }

    :first-child {
      :before {
        height: calc(100% - ${theme.spacing.km6};);
      }
    }

    ${border &&
    css`
      :before {
        content: '';
        position: absolute;
        height: calc(100% - ${theme.spacing.km6});
        top: ${theme.spacing.km6};
        left: 5px;
        width: ${theme.border.width.thinner};
        background: ${theme.color.border.neutral.default};
      }
    `}
  `}
`;

export const WrapperChildren = styled.section`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km1};
    padding-left: ${theme.spacing.km4};
  `}
`;

export const WrapperDate = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spacing.km0};
    right: ${theme.spacing.km0};
    text-transform: uppercase;
    padding: 2px ${theme.spacing.km2};
    border-radius: ${theme.border.radius.xlarge};
  `}
`;
